// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "page__wrapper-3jEbf";
var _4 = "page__header-1Qfjk";
var _5 = "page__content-3c-LS";
var _6 = "page__insurancesList-vu40y";
var _7 = "page__title-6EEQV";
var _8 = "page__subheader-2ZJVU";
var _9 = "selectForm__root-1CNyE";
var _a = "selectForm__label-1s_BG";
var _b = "selectForm__checked-14OfU";
var _c = "selectForm__radio-3t4Sb";
var _d = "selectForm__price-2PoAs";
var _e = "content__title-1AZXS";
var _f = "banner__icons-3f-jL";
var _10 = "price__content-2g8kt";
var _11 = "price_bold-3fmBy";
var _12 = "price_regular-3E8mt";
var _13 = "price_light-2SKSB";
var _14 = "price_forAllPassengers-65HWZ";
var _15 = "price__price-1qfg6";
var _16 = "banner__popularBadge-xxs7J";
var _17 = "product__content-wdCxX";
var _18 = "product__popular-gt0mx";
var _19 = "product__title-2fwkf";
var _1a = "product__description-2vGiK";
var _1b = "product__options-3zOim";
var _1c = "product__moreInfo-2Sz2-";
var _1d = "product__linksWrapper-ltFB_";
var _1e = "optionsList__list-3EEE3";
var _1f = "product__selectButton-2GJtt";
var _20 = "upsaleModal__header-jGTyo";
var _21 = "upsaleModal__listWrapper-3vYUR";
var _22 = "upsaleModal__button-10kPD";
var _23 = "upsaleModal__root-2ZVF5";
var _24 = "selectForm__priceContent-1pCig";
export { _1 as "__esModule", _2 as "mobile", _3 as "page__wrapper", _4 as "page__header", _5 as "page__content", _6 as "page__insurancesList", _7 as "page__title", _8 as "page__subheader", _9 as "selectForm__root", _a as "selectForm__label", _b as "selectForm__checked", _c as "selectForm__radio", _d as "selectForm__price", _e as "content__title", _f as "banner__icons", _10 as "price__content", _11 as "price_bold", _12 as "price_regular", _13 as "price_light", _14 as "price_forAllPassengers", _15 as "price__price", _16 as "banner__popularBadge", _17 as "product__content", _18 as "product__popular", _19 as "product__title", _1a as "product__description", _1b as "product__options", _1c as "product__moreInfo", _1d as "product__linksWrapper", _1e as "optionsList__list", _1f as "product__selectButton", _20 as "upsaleModal__header", _21 as "upsaleModal__listWrapper", _22 as "upsaleModal__button", _23 as "upsaleModal__root", _24 as "selectForm__priceContent" }
export default { "__esModule": _1, "mobile": _2, "page__wrapper": _3, "page__header": _4, "page__content": _5, "page__insurancesList": _6, "page__title": _7, "page__subheader": _8, "selectForm__root": _9, "selectForm__label": _a, "selectForm__checked": _b, "selectForm__radio": _c, "selectForm__price": _d, "content__title": _e, "banner__icons": _f, "price__content": _10, "price_bold": _11, "price_regular": _12, "price_light": _13, "price_forAllPassengers": _14, "price__price": _15, "banner__popularBadge": _16, "product__content": _17, "product__popular": _18, "product__title": _19, "product__description": _1a, "product__options": _1b, "product__moreInfo": _1c, "product__linksWrapper": _1d, "optionsList__list": _1e, "product__selectButton": _1f, "upsaleModal__header": _20, "upsaleModal__listWrapper": _21, "upsaleModal__button": _22, "upsaleModal__root": _23, "selectForm__priceContent": _24 }
